export default __webpack_public_path__ + "static/media/unlimitedJobApplicantsIcon.1132fb51.svg";